const styles = {
  configDetails: {
    position: 'relative',
    height: { xs: 'calc(100vh - 56px)', sm: 'calc(100vh - 75px)' },
    backgroundColor: '#f0f0f0',
    boxSizing: 'border-box',
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridTemplateRows: 'auto auto 1fr',
    gap: 2,
    p: 2,
  },

  headerRow: { gridColumn: '1 / -1', gridRow: '1' },

  headerBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 2,
  },

  formCard: {
    gridColumn: '1 / -1',
    gridRow: '2',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    p: 2,
    overflow: 'visible',
    borderRadius: 0,
    boxShadow: 'none',
    minWidth: 320,
    gap: 2,
  },

  tableCard: {
    gridColumn: '1 / -1',
    gridRow: '3',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    p: 2,
    minHeight: 0,
    overflow: 'hidden',
    borderRadius: 0,
    boxShadow: 'none',
    gap: 2,
  },

  fabButton: {
    width: 48,
    height: 48,
    minWidth: 48,
    minHeight: 48,
    borderRadius: '50%',
    backgroundColor: '#5236AB',
    color: '#F0F0F0',
    border: '1px solid #5236AB',
    padding: 0,
    '&:hover': { backgroundColor: '#E0E0E0' },
  },
};

export default styles;
